import React from 'react';
import Layout from '../components/Layout/Layout';

// Using a suitable document image if available, else a placeholder
import placeholderImg from '../images/abouttabvision-mission.jpg';

const RampPage = () => {
  return (
    <Layout>
      <div id="ramp-page" className="page-container" style={{ maxWidth: '1000px', margin: '40px auto', padding: '0 20px', minHeight: '500px' }}>
        
        <h1 style={{ color: '#333', fontSize: '2.5rem', fontWeight: 'bold', marginBottom: '20px' }}>
          Infrastructure - RAMP
        </h1>

        <div style={{ backgroundColor: '#aaa', minHeight: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '30px', borderRadius: '4px', overflow: 'hidden' }}>
          <div style={{ textAlign: 'center', color: '#fff', fontSize: '3rem', fontWeight: 'bold' }}>
            RAMP Document Image
          </div>
        </div>

        <p style={{ color: '#444', fontSize: '1.1rem', marginBottom: '30px', lineHeight: '1.6' }}>
          Further details on RAMP compliance: Regular internal audits are conducted to ensure that our operations align with the specified performance indicators.
        </p>

        <h2 style={{ color: '#333', fontSize: '2rem', fontWeight: 'bold', marginBottom: '20px' }}>
          RAMP Documentation:
        </h2>

        <div style={{ color: '#555', fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '30px' }}>
          <div style={{ marginBottom: '5px' }}>• RAMP Report (Latest)</div>
          <div style={{ marginBottom: '5px' }}>• Action Taken Report on RAMP</div>
          <div style={{ marginBottom: '5px' }}>• Performance Indicators</div>
          <div style={{ marginBottom: '5px' }}>• Future Compliance Plans</div>
          <div style={{ marginBottom: '5px' }}>• Stakeholder Feedback on RAMP</div>
          <div style={{ marginBottom: '5px' }}>• Accreditation Cycles & Outcomes</div>
        </div>

        <div style={{ marginTop: '30px' }}>
          <a href="#" style={{ color: 'blue', textDecoration: 'underline', fontSize: '1.1rem' }}>
            Download RAMP Report (PDF)
          </a>
        </div>

      </div>
    </Layout>
  );
};

export default RampPage;
